document.addEventListener("DOMContentLoaded", function () {
    const anchorLinks = document.querySelectorAll(
        ".header__menu-item.list-menu__item.link.link--text.focus-inset, .menu-drawer__menu-item.list-menu__item.link.link--text.focus-inset"
    );
    const menuToggleButton = document.querySelector("summary.header__icon--menu");

    anchorLinks.forEach(link => {
        link.addEventListener("click", function (event) {
            const targetId = this.getAttribute("href");

            if (window.location.pathname === "/" && targetId.startsWith("#")) {
                // Sur la page d'accueil, avec un lien d'ancre
                event.preventDefault();
                
                document.querySelector(targetId)?.scrollIntoView({ behavior: "smooth" });

                // Fermeture du menu après l'animation
                setTimeout(() => {
                    if (menuToggleButton && menuToggleButton.getAttribute("aria-expanded") === "true") {
                        menuToggleButton.click();
                    }
                }, 300);

            } else if (targetId.startsWith("#")) {
                // Si on n'est pas sur la page d'accueil, redirection vers l'ancre de la page d'accueil
                event.preventDefault();
                window.location.href = "/" + targetId;
            } else {
                // Pour les autres liens, ferme le menu et suit le lien
                if (menuToggleButton && menuToggleButton.getAttribute("aria-expanded") === "true") {
                    setTimeout(() => menuToggleButton.click(), 300);
                }
            }
        });
    });
});
